<template>
  <div name="estateIntroduce">
    <div v-if="!!infoList.length">
      <section class="info" v-for="info in infoList" :key="info.key">
        <div class="title">
          <span>{{info.title}}</span>
          <div v-if="info.title=='基本信息'" class="image" @click="jumpUrl()">
            <img class="img" src="../../../../assets/img/quanjing360.jpg" />
          </div>
        </div>
        <div class="content">
          <div
            class="infoItem"
            :class="{flex_1: item.key === 'address' || item.key === 'description'}"
            v-for="item in info.children"
            :key="item.key"
          >
            <div class="label">{{item.label}}:</div>
            <div class="value">{{item.value}}</div>
          </div>
        </div>
      </section>
    </div>
    <div style="height:80%" v-else>
      <None />
    </div>
    <el-dialog
      title="全景实况"
      width="90%"
      :visible.sync="dialogVisible"
      :before-close="handleCancelRename"
      fullscreen="true"
      center
    >
      <iframe
        id="mainIframe"
        name="mainIframe"
        src="https://720yun.com/t/ffvkuq8ed8m?scene_id=41316095"
        frameborder="0"
        scrolling="auto"
      ></iframe>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">返 回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type='text/babel'>
import None from '@/components/none.vue';
import { getEstateInfoByEstateId } from '@/api/publicinquiry.api.js';
import { getSession } from '@/untils';
export default {
  name: 'estateIntroduce',
  data() {
    const { query } = this.$route;
    return {
      query,
      infoList: [],
      baseInfoConfig: [
        { label: '小区名称', key: 'housingEstateName' },
        { label: '别名', key: 'housingEstateAlias' },
        { label: '详细地址', key: 'address' }
      ],
      planInfoConfig: [
        { label: '建筑面积(m²)', key: 'buildingArea' },
        { label: '占地面积(m²)', key: 'coveredArea' },
        { label: '产权年限', key: 'propertyPeriod' },
        { label: '容积率', key: 'plotRatio' },
        { label: '绿化率', key: 'afforestRatio' },
        { label: '地下车位数', key: 'undergroundParkingQuantity' },
        { label: '地上车位数', key: 'overgroundParkingQuantity' },
        { label: '储藏室数', key: 'storeroomQuantity' },
        { label: '供暖方式', key: 'heatingSystemName' },
        { label: '供水方式', key: 'waterSupplyName' },
        { label: '供电方式', key: 'powerSupplyName' },
        { label: '管道燃气', key: 'pipelineGasName' },
        { label: '小区介绍', key: 'description' }
      ],
      projectId: '',
      dialogVisible: false
    };
  },
  created() {
    this.projectId = getSession('projectId');
    this.getEstateInfoByEstateId();
  },
  methods: {
    jumpUrl() {
      this.dialogVisible = true;
    },
    getEstateInfoByEstateId() {
      const { id } = this.query;
      getEstateInfoByEstateId(this.projectId, id).then(res => {
        if (res.code === 0) {
          const data = res.body;
          const { estateProgrammeInfo } = data;
          const { baseInfoConfig, planInfoConfig } = this;
          const baseInfo = {
            title: '基本信息',
            key: 'baseInfo',
            children: []
          };
          const planInfo = {
            title: '规划信息',
            key: 'planInfo',
            children: []
          };
          const getInfo = (config, data, result) => {
            config.forEach(item => {
              const cell = JSON.parse(JSON.stringify(item));
              const val = data[cell.key];
              if (val) {
                cell.value = val;
                result.children.push(cell);
              }
            });
          };
          getInfo(baseInfoConfig, data, baseInfo);
          estateProgrammeInfo &&
            getInfo(planInfoConfig, estateProgrammeInfo, planInfo);
          this.infoList.splice(0, this.infoList.length);
          baseInfo.children.length && this.infoList.push(baseInfo);
          planInfo.children.length && this.infoList.push(planInfo);
        } else {
          this.$message({
            message: res.errMsg,
            type: 'warning'
          });
        }
      });
    }
  },
  components: {
    None
  }
};
</script>
<style scoped lang="less">
[name="estateIntroduce"] {
  height: 100%;
  width: 100%;
  padding: 20px 30px;
  box-sizing: border-box;
  .title {
    line-height: 36px;
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 12px;
  }
  .image {
    display: inline-block;
    line-height: 36px;
    margin-left: 20px;
    height: 36px;
    width: 36px;
    .img {
      height: 36px;
      width: 36px;
    }
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .infoItem {
      flex: 50% 0 0;
      display: flex;
      align-items: flex-start;
      margin: 6px 0;
      .label {
        flex: 170px 0 0;
        text-align: right;
      }
      .value {
        flex: 1;
        padding-left: 30px;
      }
    }
    .flex_1 {
      flex: 100% 0 0;
    }
  }
  #mainIframe {
    width: 100%;
    height: 100%;
  }
  /deep/.el-dialog__body {
    height: calc(100% - 20px);
  }
}
</style>



// WEBPACK FOOTER //
// src/page/project-system/selection/components/estateIntroduce.vue